var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "level" },
        [
          _c(
            "Header",
            _vm._b(
              { staticClass: "level-left" },
              "Header",
              _vm.$route.meta,
              false
            )
          ),
        ],
        1
      ),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "b-field",
              { attrs: { grouped: "" } },
              [
                _vm.user.group.plants && _vm.user.group.plants.length != 0
                  ? _c(
                      "b-field",
                      { attrs: { label: "Plant" } },
                      [
                        _c(
                          "b-select",
                          {
                            attrs: { icon: "industry", expanded: "" },
                            model: {
                              value: _vm.selectedPlant,
                              callback: function ($$v) {
                                _vm.selectedPlant = $$v
                              },
                              expression: "selectedPlant",
                            },
                          },
                          _vm._l(_vm.user.group.plants, function (plant) {
                            return _c(
                              "option",
                              { key: plant.id, domProps: { value: plant } },
                              [_vm._v(" " + _vm._s(plant.name) + " ")]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    )
                  : _c(
                      "b-field",
                      { attrs: { label: "Plant" } },
                      [
                        _c("multiselect", {
                          staticStyle: { "min-width": "400px" },
                          attrs: {
                            options: _vm.plants,
                            multiple: false,
                            "close-on-select": true,
                            placeholder: "Pick plant",
                            "custom-label": (obj) => obj.id + " - " + obj.name,
                            "track-by": "name",
                          },
                          model: {
                            value: _vm.selectedPlant,
                            callback: function ($$v) {
                              _vm.selectedPlant = $$v
                            },
                            expression: "selectedPlant",
                          },
                        }),
                      ],
                      1
                    ),
              ],
              1
            ),
            _c(
              "b-field",
              [
                _c(
                  "b-button",
                  {
                    staticClass: "left-right",
                    attrs: {
                      type: "is-warning",
                      "icon-left": "arrows-rotate",
                      disabled: _vm.isLoading || _vm.selectedPlant === null,
                    },
                    on: {
                      click: () => {
                        _vm.resetData()
                        _vm.getData()
                      },
                    },
                  },
                  [_vm._v(" Load ")]
                ),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "", grouped: "" } },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Stored Types" } },
                  [
                    _c("multiselect", {
                      staticStyle: { "min-width": "400px" },
                      attrs: {
                        options: _vm.types,
                        multiple: true,
                        "close-on-select": false,
                        placeholder: "Pick Types",
                        "custom-label": (obj) => obj.name,
                        "track-by": "name",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.targetStock.types,
                        callback: function ($$v) {
                          _vm.$set(_vm.targetStock, "types", $$v)
                        },
                        expression: "targetStock.types",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Target Reject %" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.targetStock.target_reject,
                        callback: function ($$v) {
                          _vm.$set(_vm.targetStock, "target_reject", $$v)
                        },
                        expression: "targetStock.target_reject",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "Maximum Stocks", grouped: "" } },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Clean Stock" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.targetStock.max_clean,
                        callback: function ($$v) {
                          _vm.$set(_vm.targetStock, "max_clean", $$v)
                        },
                        expression: "targetStock.max_clean",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Total stock" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.targetStock.max_total,
                        callback: function ($$v) {
                          _vm.$set(_vm.targetStock, "max_total", $$v)
                        },
                        expression: "targetStock.max_total",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "Safety Stocks", grouped: "" } },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Repair Stock" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.targetStock.min_repair,
                        callback: function ($$v) {
                          _vm.$set(_vm.targetStock, "min_repair", $$v)
                        },
                        expression: "targetStock.min_repair",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Dirty Stock" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.targetStock.min_dirty,
                        callback: function ($$v) {
                          _vm.$set(_vm.targetStock, "min_dirty", $$v)
                        },
                        expression: "targetStock.min_dirty",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Clean Stock" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.targetStock.min_clean,
                        callback: function ($$v) {
                          _vm.$set(_vm.targetStock, "min_clean", $$v)
                        },
                        expression: "targetStock.min_clean",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Available Stock" } },
                  [
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      model: {
                        value: _vm.targetStock.min_available,
                        callback: function ($$v) {
                          _vm.$set(_vm.targetStock, "min_available", $$v)
                        },
                        expression: "targetStock.min_available",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-button",
              {
                attrs: {
                  type: "is-success",
                  "icon-left": "save",
                  disabled: _vm.isLoading || !_vm.isLoaded,
                },
                on: {
                  click: () => {
                    _vm.saveTarget()
                  },
                },
              },
              [_vm._v(" Save ")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }